import APIClient from "../../../common/APIClient";
import {
  toggleShowAlert,
  displayError,
  SUCCESS_ALERT,
  toggleDialogBox,
} from "../commonActions";
import { getProject, resetProject } from "./projectsActions";
import { resetTasksToProject } from "../projects/tasksActions";
import { fetchProjectTaskAssignees } from "./projectTaskAssignmentActions";

const FETCH_PROJECT_TASKS = "FETCH_PROJECT_TASKS";
const SET_PROJECT_TASK = "SET_PROJECT_TASK";
const RESET_PROJECT_TASK = "RESET_PROJECT_TASK";

const client = () => {
  var apiClient = new APIClient();
  return apiClient.make();
};

export const fetchProjectTasks = () => {
  return (dispatch, getState) => {
    const projectTasks = getState().projects.projectTasks;

    console.log(projectTasks);
    // if (projectTasks.length > 0 || projectTasks === null) {
    //   return "";
    // }

    const project = getState().projects.project;
    if (Object.keys(project).length > 0) {
      client()
        .get("project-tasks/list", {
          params: {
            project_id: project.id,
          },
        })
        .then((json) => {
          const result = json.data;
          if (result) {
            let projectTasks = result.data;
            if (projectTasks.length > 0) {
              dispatch({ type: FETCH_PROJECT_TASKS, projectTasks });
            } else {
              dispatch({ type: FETCH_PROJECT_TASKS, projectTasks: null });
            }
          }
        })
        .catch((error) => {
          dispatch(displayError(error));
        });
    }
  };
};

export const saveTasksToProject = () => {
  return (dispatch, getState) => {
    const tasks = getState().tasks.tasksToProject;
    const project = getState().projects.project;

    if (tasks.length > 0) {
      const values = {
        tasks,
        project_id: project.id,
      };

      client()
        .post("project-tasks/add", values)
        .then((json) => {
          const result = json.data;
          if (result) {
            let success = result.data;
            if (success) {
              dispatch(
                toggleShowAlert(
                  true,
                  SUCCESS_ALERT,
                  "Task/s successfully added to the project."
                )
              );
              dispatch(toggleDialogBox(false));
              dispatch(resetTasksToProject());
              dispatch(resetProject());
              dispatch(getProject(project.id));
            }
          }
        })
        .catch((error) => {
          dispatch(displayError(error));
        });
    } else {
      alert("Please choose task/s.");
    }
  };
};

export const deleteProjectTask = (projectTask) => {
  return (dispatch) => {
    console.log(projectTask);
    const projecTaskId = projectTask.id;
    client()
      .get("/project-tasks/delete", {
        params: {
          project_task_id: projecTaskId,
        },
      })
      .then((json) => {
        const result = json.data;
        if (result) {
          let success = result.data;
          if (success) {
            dispatch(
              toggleShowAlert(
                true,
                SUCCESS_ALERT,
                "Project task was successfully deleted."
              )
            );
            dispatch(resetProject());
            dispatch(getProject(projectTask.project_id));
          }
        }
      })
      .catch((error) => {
        dispatch(displayError(error));
      });
  };
};

export const getProjecTask = (projectTaskId) => {
  return (dispatch) => {
    client()
      .get("/project-tasks/get", {
        params: {
          id: projectTaskId,
        },
      })
      .then((json) => {
        const result = json.data;
        if (result) {
          const projectTask = result.data;
          if (projectTask) {
            dispatch(setProjectTask(projectTask));
            dispatch(fetchProjectTaskAssignees(projectTask.id));
          }
        }
      })
      .catch((error) => {
        dispatch(displayError(error));
      });
  };
};

export const setProjectTask = (projectTask) => {
  return (dispatch) => {
    dispatch({ type: SET_PROJECT_TASK, projectTask });
  };
};

export const resetProjectTask = () => {
  return (dispatch) => {
    dispatch({ type: RESET_PROJECT_TASK });
  };
};
